import { cities } from "./cities";

// Feste Ortsvorwahl je Stadt. Angezeigt wird die lokale Nummer,
// der Anruf (tel:-Link) geht immer an die Zentrale 0177 980 77 33.
// HINWEIS: Die Platzhalter-Rufnummern (Suffix 807 77 33) durch echte
// Weiterleitungsnummern ersetzen, sobald diese geschaltet sind.
const VORWAHL = {
  koeln: "0221",
  krefeld: "02151",
  duesseldorf: "0211",
  bergheim: "02271",
  dortmund: "0231",
  luedenscheid: "02351",
  hagen: "02331",
  moenchengladbach: "02166",
  aachen: "0241",
  bonn: "0228",
  overath: "02206",
  moers: "02841",
  duisburg: "0203",
  essen: "0201",
  leverkusen: "0214",
  "bergisch-gladbach": "02204",
  pulheim: "02238",
  frechen: "02234",
  huerth: "02233",
  bruehl: "02232",
  kerpen: "02237",
};

const REAL_NUMBERS = {
  koeln: "0221 67029067",
  krefeld: "02151 4793290",
};

export const ZENTRALE_MOBIL = "0177 980 77 33";
export const ZENTRALE_MOBIL_HREF = "tel:+491779807733";

export const cityPhoneDisplay = (slug) => REAL_NUMBERS[slug] || `${VORWAHL[slug] || "0221"} 807 77 33`;

export const slugify = (s) =>
  s
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// Erzeugt aus den Stadtteil-Listen der Städte alle Bezirks-Landingpages.
// Köln ist ausgenommen: dort gibt es kuratierte Bezirksseiten unter /kfz-gutachter-koeln/<bezirk>
export const districts = cities
  .filter((c) => c.slug !== "in-der-naehe" && c.slug !== "koeln")
  .flatMap((c) =>
    (c.districts || []).map((d) => ({
      slug: `${c.slug}-${slugify(d)}`,
      path: `/kfz-gutachter-${c.slug}-${slugify(d)}`,
      citySlug: c.slug,
      cityName: c.name,
      district: d,
      phoneDisplay: cityPhoneDisplay(c.slug),
      metaTitle: `KFZ-Gutachter ${d} – ${c.name} | Schnell vor Ort`,
      metaDesc: `KFZ-Gutachter in ${c.name}-${d}: TÜV-zertifiziert, unabhängig, Begutachtung direkt bei Ihnen vor Ort. Für Unfallgeschädigte kostenlos. Direkt-Draht ${cityPhoneDisplay(c.slug)}.`,
    }))
  );

export const getDistrict = (slug) => districts.find((d) => d.slug === slug);
export const getDistrictsOfCity = (citySlug) => districts.filter((d) => d.citySlug === citySlug);
